import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';

const numberPattern:RegExp=/^\d+$/;
@Component({
  selector: 'org-role-years-component',
  templateUrl: './org-role-years.component.html'
})
export class OrgRoleYearsComponent implements OnInit, OnDestroy {
  @Output() add = new EventEmitter<any>();
  @Output() subtract = new EventEmitter<any>();
  @Input() itemNo:number;
  @Input() value:any;
  @Input() disabled:boolean;

  validationMessages: any;
  questionid:number;
  formErrors:any;
  formSegment:FormGroup;

  public getValue(){
    if(!this.disabled) {
      return this.formSegment.value;
    }
    return null;
  }

  isValid():boolean {
    if(this.disabled) {
      return true;
    }
    return !this.formSegment.errors;
  }
  validate():boolean {
    this.formSegment.controls['type'].markAsTouched();
    this.formSegment.controls['role'].markAsTouched();
    this.formSegment.controls['year'].markAsTouched();
    return this.isValid();
  }

  onAdd(){
    this.add.emit(this.value.itemNo);
  }

  onSubtract(){
    this.subtract.emit(this.value.itemNo);
  }

  get typeErr():string {
    var err:any;
    if((this.formSegment.controls['type'].dirty || this.formSegment.controls['type'].touched) && !!(err=this.formSegment.controls['type'].errors)) {
      return 'This field is required';
    }
    return '';
  }

  get roleErr():string {
    var err:any;
    if((this.formSegment.controls['role'].dirty || this.formSegment.controls['role'].touched) && !!(err=this.formSegment.controls['role'].errors)) {
      return 'This field is required';
    }
    return '';
  }

  get yearErr():string {
    var err:any;
    if((this.formSegment.controls['year'].dirty || this.formSegment.controls['year'].touched) && !!(err=this.formSegment.controls['year'].errors)) {
      if(!!err.required) {
        return 'This field is required.';
      }
      return 'Please enter only digits.';
    }
    return '';
  }

  constructor() {
  }

  ngOnInit() {
    var init={};
    init['type']=new FormControl(this.value.type,[Validators.required]);
    init['role']=new FormControl(this.value.role,[Validators.required]);
    init['year']=new FormControl(this.value.year,[Validators.required,Validators.pattern(numberPattern)]);

    this.formSegment=new FormGroup(init);
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/org-role-years.component.ts